import { ChevronLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export function ChildDetailsHeader({ childName, onBackClick }: any) {
  return (
    <div className="flex items-center relative w-full ">
      {/* Back Button */}
      <Button
        variant="ghost"
        onClick={onBackClick}
        className="flex items-center justify-center rounded-[12px] size-[38px] shrink-0 p-0"
      >
        <ChevronLeft
          size={28}
          className="text-[var(--color-black-9)]"
          style={{
            width: "28px",
            height: "28px",
            minWidth: "28px",
            minHeight: "28px",
          }}
        />
      </Button>

      {/* Title */}
      <div className="flex-1 min-w-0 px-2">
        <p className="text-b2-mid">{childName}</p>
      </div>
    </div>
  );
}
